import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { getImgFromStr, getDateTimeStamp, getDateDiff } from "../../unit/public";
import PostFootFunction from "./PostFootFunction";
export default {
  props: ["blogs"],
  components: {
    PostFootFunction: PostFootFunction
  },
  name: "post-card",
  data: function data() {
    return {};
  },
  methods: {
    imgFromStr: function imgFromStr(json_metadata, body) {
      var imgurl = getImgFromStr(json_metadata, body);
      return imgurl || imgurl != "" ? imgurl : "/img/brand/DefaultPost.png";
    },
    dateDiff: function dateDiff(dateTime) {
      return getDateDiff(getDateTimeStamp(dateTime));
    }
  },
  computed: {
    postLink: function postLink() {
      return "/" + this.blogs.category + "/@" + this.blogs.author + "/" + this.blogs.permlink;
    }
  },
  watch: {},
  mounted: function mounted() {
    /*   let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://static.like.co/sdk/v1/button.js";
    document.body.appendChild(script); */

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};